<div class="all-in-one-table content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs [url]="'Xl Mapper'" [currentPage]="'Xl Mapper'" [header]="'primary'">
        </calsoft-breadcrumbs>


        <div fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <button [attr.guide]="'xl-mapper-btn-1-1' + '__' + sanitizedUrl" (click)="back()"
                                matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            {{title}}
                        </div>
                    </div>

                    <div class="padding-10" fxLayout="column" fxLayoutGap="10px">
                        <div class="editSets1">
                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                <span>Excel</span>
                            </div>
                            <div class="products-padding" fxLayout="row" fxLayoutAlign="start center">

                                <mat-stepper orientation="{{orientation}}" style="width: 100%;" fxFlex [linear]="true"
                                    #stepper>

                                    <mat-step [stepControl]="secondFormGroup" label="Import">

                                        <form [formGroup]="secondFormGroup">
                                            <div *ngIf="!fileUpload">


                                                <!-- Custom Upload Section (Visible when no file is selected) -->
                                                <div class="upload-wrapper" *ngIf="!selectedFile">
                                                    <div class="cloud-icon-container">
                                                        <mat-icon>cloud_upload</mat-icon>
                                                    </div>
                                                    <div class="file-status-text">
                                                        No file selected.
                                                    </div>
                                                    <input #fileInput
                                                        [attr.guide]="'xl-mapper-inp-2-1' + '__' + sanitizedUrl"
                                                        type="file" style="display: none;"
                                                        (change)="onFileSelected($event)" placeholder="Upload file"
                                                        accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" />
                                                    <button type="button" mat-flat-button class="choose-file-btn"
                                                        (click)="fileInput.click()">
                                                        Choose File
                                                    </button>
                                                </div>

                                                <!-- Invalid File Format Error -->
                                                <div class="invalid-format-error" *ngIf="invalidFileFormat">
                                                    <mat-icon class="error-icon">error_outline</mat-icon>
                                                    <span>Invalid file format. Please upload a <strong>.csv</strong>,
                                                        <strong>.xlsx</strong>, or <strong>.xls</strong> file.</span>
                                                    <button type="button" class="dismiss-error-btn"
                                                        (click)="invalidFileFormat = false">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                </div>

                                                <!-- File Selected Card (Visible when a file is chosen, mimicking knowledge-base-popup) -->
                                                <div class="file-selected-card" *ngIf="selectedFile">
                                                    <div class="file-info">
                                                        <mat-icon class="file-icon">description</mat-icon>
                                                        <div class="file-details">
                                                            <div class="filename">{{ selectedFile.name }}</div>
                                                            <div class="filesize">{{ formatFileSize(selectedFile.size)
                                                                }}</div>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="remove-file-btn"
                                                        (click)="removeFile()">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                </div>

                                                <!-- Upload Confirm Action (only when a file is selected) -->
                                                <div class="upload-actions" *ngIf="selectedFile" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <button [attr.guide]="'xl-mapper-btn-3-1' + '__' + sanitizedUrl"
                                                        mat-raised-button class="upload-confirm-btn"
                                                        [disabled]="isUploading"
                                                        (click)="uploadFile()">{{ isUploading ? 'Processing...' : 'Upload' }}</button>
                                                    <mat-spinner *ngIf="isUploading" diameter="24"></mat-spinner>
                                                </div>
                                            </div>




                                            <div *ngIf="fileUpload" class="products-padding" fxLayout="row">
                                                File Uploaded Successfully Procced to Next Step
                                            </div>


                                        </form>
                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">


                                            <button [attr.guide]="'xl-mapper-btn-4-1' + '__' + sanitizedUrl"
                                                ngStyle.lt-sm="width: 100%;" (click)="goToStep3(stepper)"
                                                mat-raised-button color="primary">Next</button>

                                        </div>



                                    </mat-step>

                                    <mat-step [stepControl]="firstFormGroup" label="XL Mapper">

                                        <div [formGroup]="firstFormGroup" class="padding-11">

                                            <div class="editSets1">
                                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                                    <span>Source Mapper</span>
                                                </div>


                                                <div>
                                                    <div class="result" fxLayout="column">

                                                        <div color="warn">
                                                            <div fxLayout="row wrap" fxFlex="100">
                                                                <div color="warn" fxFlex="100">
                                                                    <div formArrayName="sourceMapper"
                                                                        *ngFor="let Profileadd of firstFormGroup.get('sourceMapper')['controls']; let i = index">
                                                                        <div [formGroupName]="i"
                                                                            class="mapper-row-container">
                                                                            <div class="mapper-row">
                                                                                <div class="field-col">
                                                                                    <mat-form-field appearance="outline"
                                                                                        style="width: 100%;">
                                                                                        <mat-label>Form Fields
                                                                                            Mapper</mat-label>
                                                                                        <mat-select
                                                                                            [disableOptionCentering]="true"
                                                                                            #singleSelect
                                                                                            formControlName="fieldMapper"
                                                                                            autocomplete="off">
                                                                                            <mat-option
                                                                                                [disabled]="true"
                                                                                                *ngFor="let key of mapperKeys"
                                                                                                [value]="key">
                                                                                                {{ key }}
                                                                                            </mat-option>
                                                                                        </mat-select>
                                                                                    </mat-form-field>
                                                                                </div>

                                                                                <div class="field-col">
                                                                                    <mat-form-field appearance="outline"
                                                                                        style="width: 100%;">
                                                                                        <mat-label>Form
                                                                                            Fields</mat-label>
                                                                                        <mat-select
                                                                                            [disableOptionCentering]="true"
                                                                                            #singleSelect
                                                                                            formControlName="formFields"
                                                                                            autocomplete="off">
                                                                                            <mat-option>
                                                                                                <ngx-mat-select-search
                                                                                                    name="Fields search"
                                                                                                    ngDefaultControl
                                                                                                    [formControl]="attributeFilterControl"
                                                                                                    placeholderLabel="Search"
                                                                                                    [preventHomeEndKeyPropagation]="true"
                                                                                                    noEntriesFoundLabel="No data found">
                                                                                                </ngx-mat-select-search>
                                                                                            </mat-option>
                                                                                            <mat-option
                                                                                                [disabled]="isFieldAlreadySelected(opt.attributeCode, i)"
                                                                                                *ngFor="let opt of filteredAttributeTypeList; let optIndex=index;"
                                                                                                [value]="opt.attributeCode">
                                                                                                {{opt.frontendLabel}}
                                                                                            </mat-option>
                                                                                        </mat-select>
                                                                                    </mat-form-field>
                                                                                </div>

                                                                                <div class="delete-col">
                                                                                    <button
                                                                                        [attr.guide]="'xl-mapper-btn-5-1' + '__' + sanitizedUrl"
                                                                                        [disabled]="i<1" mat-icon-button
                                                                                        color="warn"
                                                                                        (click)="removeOption(i)">
                                                                                        <mat-icon>delete</mat-icon>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">

                                            <button [attr.guide]="'xl-mapper-btn-6-1' + '__' + sanitizedUrl"
                                                ngStyle.lt-sm="width: 100%;" (click)="goToStep(stepper)"
                                                mat-raised-button color="primary">Next</button>

                                        </div>

                                    </mat-step>

                                    <mat-step label="Sequence" *ngIf="+enableSequences === 1">

                                        <div [formGroup]="firstFormGroup" class="padding-11">

                                            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">


                                                <mat-form-field fxFlex appearance="outline">
                                                    <mat-label>Time Zone</mat-label>
                                                    <mat-select formControlName="TimeZone"
                                                        [disableOptionCentering]="true" #singleSelect>
                                                        <mat-option>
                                                            <ngx-mat-select-search name="Time Zone Search"
                                                                ngDefaultControl [formControl]="filterCtrl"
                                                                placeholderLabel="Time Zone Search"
                                                                [preventHomeEndKeyPropagation]="true"
                                                                noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="let opt of filteredStatus"
                                                            [value]="opt.value">
                                                            {{opt.label}}
                                                        </mat-option>
                                                    </mat-select>

                                                </mat-form-field>

                                            </div>

                                            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                                                <mat-form-field fxFlex appearance="outline">
                                                    <mat-label>Sequences</mat-label>
                                                    <input type="text" matInput [formControl]="typeYFilterControl" [matAutocomplete]="autoSequence" placeholder="Search Sequences" autocomplete="off" />
                                                    <mat-icon *ngIf="firstFormGroup.get('sequenceNo')?.value || typeYFilterControl.value" matSuffix (click)="firstFormGroup.get('sequenceNo').setValue(null); typeYFilterControl.setValue('')" style="cursor: pointer;">clear</mat-icon>
                                                    <mat-autocomplete #autoSequence="matAutocomplete">
                                                        <mat-option
                                                            *ngFor="let opt of filteredSequencesdropdownTypeList; let i=index;"
                                                            [value]="opt.sequenceName"
                                                            (onSelectionChange)="$event.isUserInput ? firstFormGroup.get('sequenceNo').setValue(opt.sequenceId) : null">
                                                            {{opt.sequenceName}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                            </div>

                                        </div>

                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">

                                            <button [attr.guide]="'xl-mapper-btn-8-1' + '__' + sanitizedUrl"
                                                ngStyle.lt-sm="width: 100%;" (click)="goToStep(stepper)"
                                                mat-raised-button color="primary">Next</button>

                                        </div>

                                    </mat-step>


                                    <mat-step label="Data">

                                         <div *ngIf="text === 'Processing'" fxLayout="column"
                                             fxLayoutAlign="center center" style="padding: 40px;">
                                             <mat-spinner diameter="40"></mat-spinner>
                                             <p style="margin-top: 15px; color: #555;">Processing Mapped Data...</p>
                                         </div>

                                        <div *ngIf="text !== 'Processing' && mappedPreview.length > 0" class="card p-4 shadow-sm">

                                            <h5 class="mb-3">Mapped Data Preview</h5>

                                                <div class="table-responsive" style="max-height: 400px; overflow: auto;">
                                                     <mat-table [dataSource]="dataSource" class="w-full">

                                                        <ng-container *ngFor="let column of displayedFormFields"
                                                            [matColumnDef]="column">
                                                            <mat-header-cell *matHeaderCellDef> {{ column
                                                                }}</mat-header-cell>
                                                            <mat-cell *matCellDef="let row">
                                                                <span
                                                                    [ngStyle]="{'color': row.isValid === false ? 'red' : 'inherit'}"
                                                                    [matTooltip]="row.errorMessage || ''">
                                                                    {{ row[column] }}
                                                                </span>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <ng-container matColumnDef="actions">
                                                            <mat-header-cell *matHeaderCellDef> Actions
                                                            </mat-header-cell>
                                                            <mat-cell *matCellDef="let row">
                                                                <div *ngIf="!row.isValid" fxLayout="row"
                                                                    fxLayoutAlign="start center"
                                                                    style="color: #f44336; margin-right: 16px;">
                                                                    <mat-icon
                                                                        style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px;">error_outline</mat-icon>
                                                                    <small style="white-space: nowrap;">{{
                                                                        row.errorMessage }}</small>
                                                                </div>
                                                                <button mat-icon-button color="primary"
                                                                    (click)="openEditDialog(row, editDialog)">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                                <button
                                                                    [attr.guide]="'xl-mapper-btn-9-1' + '__' + sanitizedUrl"
                                                                    (click)="deleteRow(row)" mat-icon-button>
                                                                    <mat-icon>delete</mat-icon>
                                                                </button>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <mat-header-row
                                                            *matHeaderRowDef="displayedFormFields.concat(['actions'])" [sticky]="true"></mat-header-row>
                                                        <mat-row
                                                            *matRowDef="let row; columns: displayedFormFields.concat(['actions']);"
                                                            class="clickable"></mat-row>

                                                    </mat-table>

                                                    <ng-template #editDialog let-data>
                                                        <div style="padding: 24px; box-sizing: border-box;"
                                                            fxLayout="column">
                                                            <div fxLayout="row" fxLayoutAlign="space-between center"
                                                                style="margin-bottom: 24px;">
                                                                <h2 mat-dialog-title
                                                                    style="margin: 0; font-size: 20px; font-weight: 500;">
                                                                    Edit Mapped Data</h2>
                                                                <mat-icon mat-dialog-close
                                                                    style="cursor: pointer; color: #888;">close</mat-icon>
                                                            </div>
                                                            <mat-dialog-content
                                                                style="margin: 0; padding: 4px; overflow-y: auto; overflow-x: hidden; max-height: 60vh;">
                                                                <div fxLayout="column" fxLayoutGap="16px">
                                                                    <mat-form-field
                                                                        *ngFor="let col of displayedFormFields"
                                                                        appearance="outline" style="width: 100%;">
                                                                        <mat-label>{{ col }}</mat-label>
                                                                        <input matInput
                                                                            [(ngModel)]="data.editingRow[col]" />
                                                                    </mat-form-field>
                                                                </div>
                                                            </mat-dialog-content>
                                                            <mat-dialog-actions align="end"
                                                                style="margin: 0; padding-top: 24px;">
                                                                <button mat-button mat-dialog-close
                                                                    style="margin-right: 8px;">Cancel</button>
                                                                <button mat-raised-button color="primary"
                                                                    (click)="saveEdit(data)">Save Changes</button>
                                                            </mat-dialog-actions>
                                                        </div>
                                                    </ng-template>
                                                    <div style="padding: 20px;" fxLayoutAlign="center center"
                                                        *ngIf="mappedPreview?.length === 0">
                                                        No records found
                                                    </div>



                                                </div>

                                             <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>

                                         </div>


                                        <div *ngIf="text !== 'Processing'" style="padding-top: 10px;" fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">


                                            <div *ngIf="mappedPreview.length > 0; else noData" fxLayout="row"
                                                fxLayout.lt-sm="column" fxLayoutGap="10px"
                                                style="width: 100%; justify-content: flex-end;">

                                                <button [attr.guide]="'xl-mapper-btn-10-1' + '__' + sanitizedUrl"
                                                    mat-button style="color: black;" ngStyle.lt-sm="width: 100%;"
                                                    matStepperPrevious>Back</button>

                                                <button [attr.guide]="'xl-mapper-btn-11-1' + '__' + sanitizedUrl"
                                                    mat-raised-button [disabled]="isUploading"
                                                    ngStyle.lt-sm="width: 100%;" (click)="finalUpload(stepper)">
                                                    {{textNew}}
                                                    <mat-icon *ngIf="isUploading">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>

                                            <ng-template #noData>
                                                <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px"
                                                    style="width: 100%; justify-content: flex-end; align-items: center;">
                                                    <button [attr.guide]="'xl-mapper-btn-12' + '__' + sanitizedUrl"
                                                        style="color: black;" mat-raised-button
                                                        ngStyle.lt-sm="width: 100%;" matStepperPrevious>Back</button>
                                                    <p style="color: red; font-weight: bold; margin: 0;">No data
                                                        mapped.
                                                    </p>
                                                </div>
                                            </ng-template>

                                        </div>

                                    </mat-step>


                                    <mat-step label="Done">
                                         <!-- Case 1: Import is in progress -->
                                         <div *ngIf="isProcessing" fxLayout="column" fxLayoutAlign="center center" class="padding-20" fxLayoutGap="15px">
                                             <mat-spinner color="primary" diameter="50"></mat-spinner>
                                             <h3 style="margin-top: 10px;">Import in Progress</h3>
                                             <p style="color: #666; font-size: 14px;">{{ progressMessage }}</p>
                                         </div>

                                         <!-- Case 2: Import completed -->
                                         <div *ngIf="isCompleted">
                                             <div class="products-padding" fxLayout="column" fxLayoutGap="12px" style="margin-bottom: 20px;">
                                                 <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="font-weight: bold; font-size: 16px;">
                                                     <span style="color: #4caf50;">Successfully Uploaded: {{ successCount }}</span>
                                                     <span>|</span>
                                                     <span style="color: #f44336;">Failed to Upload: {{ failedCount }}</span>
                                                 </div>
                                                 <div style="margin-top: 8px; color: #555;">
                                                     Excel Import Process has finished.
                                                 </div>
                                             </div>
                                         </div>

                                         <!-- If neither processing nor completed (fallback to old text) -->
                                         <div *ngIf="!isProcessing && !isCompleted">
                                             <p>Excel Import Initiated Successfully.</p>
                                         </div>

                                         <div *ngIf="showSuccessRecords || showFailedRecords" class="padding-10" style="margin-top: 15px;">
                                             <mat-tab-group dynamicHeight>
                                                 <!-- Tab 1: Successfully Uploaded Records -->
                                                 <mat-tab label="Success ({{ successCount }})" *ngIf="showSuccessRecords">
                                                     <div style="overflow-x:auto; padding-top: 15px;">
                                                         <div class="table-container">
                                                             <table>
                                                                 <thead>
                                                                     <tr>
                                                                         <th *ngFor="let col of successColumns">{{ col }}</th>
                                                                     </tr>
                                                                 </thead>
                                                                 <tbody>
                                                                     <tr *ngFor="let row of successRecords">
                                                                         <td *ngFor="let col of successColumns">
                                                                             {{ col === 'createdAt' ? (row[col] | date:'short') : row[col] }}
                                                                         </td>
                                                                     </tr>
                                                                 </tbody>
                                                             </table>
                                                         </div>
                                                     </div>
                                                 </mat-tab>

                                                 <!-- Tab 2: Failed Records -->
                                                 <mat-tab label="Failed ({{ failedCount }})" *ngIf="showFailedRecords">
                                                     <div style="overflow-x:auto; padding-top: 15px;">
                                                         <div class="table-container">
                                                             <table>
                                                                 <thead>
                                                                     <tr>
                                                                         <th *ngFor="let col of columns">{{ col }}</th>
                                                                     </tr>
                                                                 </thead>
                                                                 <tbody>
                                                                     <tr *ngFor="let row of failedRecords">
                                                                         <td *ngFor="let col of columns">
                                                                             {{ col === 'createdAt' ? (row[col] | date:'short') : row[col] }}
                                                                         </td>
                                                                     </tr>
                                                                 </tbody>
                                                             </table>
                                                         </div>
                                                     </div>
                                                 </mat-tab>
                                             </mat-tab-group>
                                         </div>

                                         <div fxLayout="row" fxLayoutAlign.gt-md="end center"
                                             fxLayoutAlign.lt-md="start center" fxLayoutGap="10px" style="margin-top: 20px;">
                                             <button [attr.guide]="'xl-mapper-btn-13' + '__' + sanitizedUrl"
                                                 ngStyle.lt-sm="width: 100%;" (click)="goToProductPage()"
                                                 mat-raised-button color="primary">Next</button>
                                         </div>
                                     </mat-step>

                                </mat-stepper>



                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

